import { useChatContext } from './hooks';

export function useInsightContext(uri, label, link, options) {
    useChatContext({
        type: 'insight',
        uri,
        label,
        link,
        source: options?.source || 'auto',
        enabled: options?.enabled ?? !!uri,
    });
}

export function usePageContext({ uri, label, link, enabled, source }) {
    useChatContext({
        type: 'page',
        uri,
        label,
        link,
        source: source || 'auto',
        enabled: enabled ?? !!uri,
    });
}
